import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { GoinZoneShapeType } from '../../../../types'

interface IMapProps {
  onMapMounted?: (map: google.maps.Map) => void
  enableDrawingManager: boolean
  color: string
  onAddedShape: (shape: any) => void
}

interface IMapState {
  map: google.maps.Map | null
  center: google.maps.LatLng
  zoom: number
}

class Map extends React.Component<IMapProps, IMapState> {
  public drawingManager: any = null

  constructor(props: IMapProps) {
    super(props)
    this.state = {
      map: null,
      zoom: 8,
      center: new google.maps.LatLng(27.972572, -82.796745)
    }
  }

  public componentDidMount() {
    this.initMaps()
  }

  public render() {
    this.onRerenderRequest()

    return <div style={{ height: '100%' }} />
  }

  private initMaps() {
    const div: any = ReactDOM.findDOMNode(this)
    const map = new google.maps.Map(div, {
      center: this.state.center,
      zoom: this.state.zoom,
      fullscreenControl: false,
      streetViewControl: false,
      mapTypeControl: false
    })
    this.setState({
      map
    })
    if (this.props.onMapMounted) {
      this.props.onMapMounted(map)
    }
  }

  private setDrawingManager = (enable: boolean) => {
    if ((enable && !!this.drawingManager) || (!enable && !!this.drawingManager)) {
      google.maps.event.clearListeners(this.drawingManager, 'circlecomplete')
      google.maps.event.clearListeners(this.drawingManager, 'polygoncomplete')
      this.drawingManager.setMap(null)
      this.drawingManager = null
    }
    if (!enable && !!!this.drawingManager) {
      return
    }
    const onShapeCircleComplete = (p: any) => {
      const center = { lng: p.getCenter().lng(), lat: p.getCenter().lat() }
      this.props.onAddedShape({
        mapObject: p,
        innerType: GoinZoneShapeType.SHAPE_CIRCLE,
        center
      })
    }
    const onShapePolygonComplete = (p: any) => {
      const vertices = p.getPath()
      const center = { lng: 0, lat: 0 }

      for (let i = 0; i < vertices.length; i++) {
        center.lng += vertices.getAt(i).lng()
        center.lat += vertices.getAt(i).lat()
      }

      center.lng /= vertices.getLength()
      center.lat /= vertices.getLength()

      this.props.onAddedShape({
        mapObject: p,
        innerType: GoinZoneShapeType.SHAPE_POLYGON,
        center
      })
    }
    const drawingManager = new google.maps.drawing.DrawingManager({
      drawingControl: true,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_LEFT,
        drawingModes: [google.maps.drawing.OverlayType.CIRCLE, google.maps.drawing.OverlayType.POLYGON]
      },
      circleOptions: {
        fillColor: this.props.color,
        fillOpacity: 0.4,
        strokeWeight: 1,
        clickable: true,
        editable: true,
        zIndex: 1
      },
      polygonOptions: {
        fillColor: this.props.color,
        fillOpacity: 0.4,
        strokeWeight: 1,
        clickable: true,
        editable: true,
        zIndex: 1
      }
    })
    google.maps.event.addListener(drawingManager, 'circlecomplete', (shape: any) => {
      onShapeCircleComplete(shape)
    })
    google.maps.event.addListener(drawingManager, 'polygoncomplete', (shape: any) => {
      onShapePolygonComplete(shape)
    })
    drawingManager.setMap(this.state.map)
    this.drawingManager = drawingManager
  }

  private onRerenderRequest = () => {
    this.setDrawingManager(this.props.enableDrawingManager)
  }
}

export default Map



// WEBPACK FOOTER //
// ./src/components/services/edit/goinzones/Map.tsx